import dayjs from '~/timeInit';

import { formatDateWithClock } from '~/services/TimeService';

const dateFormatter = (date) => {
  if (date) {
    return formatDateWithClock(date);
  }

  return '';
};

export default dateFormatter;

/**
 * Ensures a date string has an ISO 8601 time component.
 * Appends `T00:00:00.000Z` to bare `YYYY-MM-DD` values.
 */
export function normalizeToISODate(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  return trimmed.includes('T') ? trimmed : `${trimmed}T00:00:00.000Z`;
}

/**
 * `datetime-local` (`YYYY-MM-DDTHH:mm`) → ISO instant; bare `YYYY-MM-DD` via `normalizeToISODate`.
 */
export function normalizeFormDateStringToIso(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(trimmed)) {
    return dayjs(trimmed).toISOString();
  }
  return normalizeToISODate(trimmed);
}

/**
 * Default date (YYYY-MM-DD) for "add voucher users" expiry from voucher settings:
 * fixed `voucher_user_expires_at`, else today + `voucher_user_expires_in_days`, else +1 year.
 */
export function getDefaultAddVoucherUsersExpiryDate(params: {
  voucherUserExpiresAt: string;
  voucherUserExpiresInDays: string;
}): string {
  const at = params.voucherUserExpiresAt.trim();
  if (at) {
    return dayjs(at).format('YYYY-MM-DD');
  }
  const daysTrimmed = params.voucherUserExpiresInDays.trim();
  if (daysTrimmed !== '') {
    const parsed = Number.parseInt(daysTrimmed, 10);
    if (!Number.isNaN(parsed) && parsed >= 0) {
      return dayjs().add(parsed, 'day').format('YYYY-MM-DD');
    }
  }
  return dayjs().add(1, 'year').format('YYYY-MM-DD');
}
